import React from 'react';
import './style.scss';
import Button from '../Shared/components/controls/Button';
import clsx from 'clsx';
import { Image, RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';
import { renderDate } from '../Shared/Helpers/dateTimeHelper';
import { withTranslation } from 'react-i18next';

const HeaderCasaComponent = (props) => {
  if (!props?.fields || !props.params) {
    return <GenericPlaceholder componentName="HeaderCasaComponent" />;
  }
  const {
    subtitle,
    title,
    image,
    primaryButton,
    secondaryButton,
    tertiaryButton,
    description,
    offerCategories,
    validityEnd,
    backgroundColor,
  } = props?.fields;
  const { params, t, i18n } = props;
  const { theme } = params;

  const shouldRenderImage = !!image?.value?.src;
  const shouldRenderSubtitle = !!subtitle?.value;
  const shouldRenderBackgroundColor = !!backgroundColor?.value;
  const shouldRenderTitle = !!title?.value;
  const shouldRenderDescription = !!description?.value;
  const shouldRenderPrimaryButton = !!primaryButton?.value?.href;
  const shouldRenderSecondaryButton = !!secondaryButton?.value?.href;
  const shouldRenderTertiaryButton = !!tertiaryButton?.value?.href;
  const shouldRenderOfferCategories = Array.isArray(offerCategories) && offerCategories?.length > 0;
  const shouldRenderAnyButton =
    shouldRenderPrimaryButton || shouldRenderSecondaryButton || shouldRenderTertiaryButton;
  const txt_nonExpiringOffer = t('nonExpiringOffer');
  const txt_endsIn = t('offerExpiredIn');

  const lang = i18n.language;
  const shouldRenderValidityEnd = !!validityEnd?.value && !validityEnd?.value?.startsWith('0001');

  return (
    <div
    /*style={{
      backgroundColor: shouldRenderBackgroundColor && backgroundColor ? backgroundColor.value : '', // Apply background color from Sitecore
    }}*/
      className={clsx(
        theme,
        'header-casa flex-it flex-align-item-center content',
        'add-margins',
        shouldRenderAnyButton ? 'contains-buttons' : 'no-buttons',
        shouldRenderOfferCategories ? 'variationTwo' : '',
        shouldRenderValidityEnd ? 'withValidity' : '',
        params?.Styles
      )}
    >
      
      <div className="part right">
        <figure>{shouldRenderImage && <Image field={image} />}</figure>
      </div>
      <div className="part left">
        <div className="wrap flex-it flex-align-items-center">
          <div className="auto">
            {shouldRenderOfferCategories && (
              <div className="offerCategories-list">
                {offerCategories?.slice(0, 3)?.map((category, index) => {
                  return (
                    <a className="category-item flex-inline" href={category?.url} key={index}>
                      {category?.displayName ?? category?.name}
                    </a>
                  );
                })}
              </div>
            )}
            <div className="topTitle">{shouldRenderSubtitle && <Text field={subtitle} />}</div>
            {shouldRenderTitle && <RichText className="bigTitle" field={title} />}
            <div className="btn-text-wrap">
              {shouldRenderDescription && <RichText className="description" field={description} />}

              {!!validityEnd?.value && (
                <div className="icon-text timeFrame flex-it flex-align-item-center">
                  <span className="icon">
                    <img src={`/-/jssmedia/Project/FAB2/shared/images/icon-clock.svg`} />
                  </span>
                  {shouldRenderValidityEnd && (
                    <span>
                      {txt_endsIn.replace('{0}', renderDate(validityEnd?.value, lang, 'm d, y'))}
                    </span>
                  )}
                  {!shouldRenderValidityEnd && <span>{txt_nonExpiringOffer}</span>}
                </div>
              )}
              <div className="wrap-buttons flex-it flex-wrap">
                {shouldRenderPrimaryButton && (
                  <Button link={primaryButton} variant="contained" color="primary" />
                )}
                {shouldRenderSecondaryButton && (
                  <Button link={secondaryButton} variant="outlined" color="primary" />
                )}
                {shouldRenderTertiaryButton && (
                  <Button link={tertiaryButton} variant="text" color="primary" arrow="right" />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(HeaderCasaComponent);
